import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { ItemsComponent } from '@emm/management/components/items/items.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmItemsDeactivateGuard  {

    canDeactivate(
        component: ItemsComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfItemHasChanges(component.prevItem)
            .pipe(take(1));
    }

}
